import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { ref, computed } from 'vue'


const __default__ = {
  inheritAttrs: false
}

export default _defineComponent({
  ...__default__,
  expose: [],
  props: {
  modelValue: {}
},
  setup(__props) {


const show = ref(false)
const type = computed(() => (show.value ? 'text' : 'password'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("i", {
      title: "Prikaži geslo",
      class: "fa fa-eye-slash cursor-hand",
      style: {"position":"absolute","right":"10px","top":"10px","z-index":"1"},
      "aria-hidden": "true",
      onMousedown: _cache[1] || (_cache[1] = ($event: any) => (show.value = true)),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (show.value = false)),
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (show.value = false))
    }, null, 544), [
      [_vShow, __props.modelValue]
    ]),
    _createVNode("input", _mergeProps({
      type: _unref(type),
      class: "form-input",
      autocomplete: "one-time-code"
    }, _ctx.$attrs, {
      value: __props.modelValue,
      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, ["type", "value"])
  ]))
}
}

})